import React from "react"
import { StyleProp, View, ViewStyle } from "react-native"

export function Spacer({ style }: { style?: StyleProp<ViewStyle> }) {
  return <View style={[{ flex: 1 }, style]} />
}
